import {FC, ReactNode} from 'react'
import {useTranslation} from '@/translations/i18n.tsx'
import {useVideoUpload} from '@features/video-upload/store.ts'
import {ModalCloseButton, ModalHeader} from '@components/ui/modal-atoms'
import {Dialog, DialogClose, DialogContent} from '@components/ui/dialog'

export const VideoUploadModalWrapper: FC<{children: ReactNode}> = ({children}) => {
    const {t} = useTranslation()
    const step = useVideoUpload(store => store.step)
    const setIsOpen = useVideoUpload(store => store.setIsOpen)

    return (
        <Dialog open={true} onOpenChange={() => setIsOpen(false)}>
            <DialogContent
                className="w-120 grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden"
                showCloseButton={false}
            >
                <ModalHeader className="relative py-[18px] px-6 text-center text-sm font-bold [&>button]:absolute [&>button]:top-2.5 [&>button]:left-2">
                    <DialogClose
                        data-slot="dialog-close"
                        render={<ModalCloseButton disabled={step == 'gettingLink' || step == 'uploading'} />}
                    />
                    {t('assignment:upload_video_clip')}
                </ModalHeader>
                {children}
            </DialogContent>
        </Dialog>
    )
}
